





















































































































































































































































































































import {
  Vue,
  Prop,
  Component,
} from "@/shared/vuepack";
import {
  DrivewealthEnrollmentDraft,
  DrivewealthWizardStep
} from "@/shared/types";
import { Validator } from "vee-validate";
import * as drivewealth from "@/shared/custodianSettings/drivewealthTypes";
import { countries } from "./countries";
import WizardNavigation from "@/employee/components/investments/drivewealth/wizard/WizardNavigation.vue";
import { useDrivewealthWizardStore } from "@/shared/store/drivewealthWizard";

@Component({
  components: {
    WizardNavigation,
  }
})
export default class RequiredDisclosures extends Vue {
  @Prop()
  isSavingAccountClaims: boolean;

  $validator: Validator;
  countries = countries;

  drivewealthWizardStore = useDrivewealthWizardStore();

  employmentStatusContainer = drivewealth.employmentStatusFactory();
  jobSectorContainer = drivewealth.jobSectorFactory();
  occupationContainer = drivewealth.occupationFactory();

  mounted () {
    if (this.drivewealthWizardStore.draftIsDirty) {
      this.validate();
    }
    if (this.isSavingAccountClaims && !this.hasSignatureContent) {
      this.drivewealthWizardStore.clearEnrollmentData({});
    }
  }

  validate () {
    this.$validator
        .validate();
  }

  tryAdvance () {
    this.$validator
        .validate()
        .then(isValid => {
          if (isValid) {
            this.drivewealthWizardStore.setWizardStepComplete(DrivewealthWizardStep.SelectAccountType);
            this.drivewealthWizardStore.setWizardStepComplete(this.wizardStep);
          }
        });
  }

  get wizardStep () {
    return DrivewealthWizardStep.RequiredDisclosures;
  }

  get employmentStatus () {
    return this.drivewealthWizardStore.disclosureEmploymentStatus;
  }

  set employmentStatus (value: drivewealth.EmploymentStatus) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "employmentStatus", value });
  }

  get isRequiredSectorAndOccupation () {
    return this.drivewealthWizardStore.disclosureEmploymentStatus === "EMPLOYED" ||
        this.drivewealthWizardStore.disclosureEmploymentStatus === "SELF_EMPLOYED";
  }

  get jobSector () {
    return this.drivewealthWizardStore.disclosureEmploymentType;
  }

  set jobSector (value: drivewealth.JobSector) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "employmentType", value });
  }

  get occupation () {
    return this.drivewealthWizardStore.disclosureOccupation;
  }

  set occupation (value: drivewealth.Occupation) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "occupation", value });
  }

  get citizenship () {
    return this.drivewealthWizardStore.disclosureCitizenship;
  }

  set citizenship (value: string) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "citizenship", value });
  }

  get isBroker () {
    return this.drivewealthWizardStore.disclosureIsBroker;
  }

  set isBroker (value: boolean) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "isBroker", value });
  }

  get isDirectorOrOwner () {
    return this.drivewealthWizardStore.disclosureIsDirector;
  }

  set isDirectorOrOwner (value: boolean) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "isDirector", value });
  }

  get directedCompany () {
    return this.drivewealthWizardStore.disclosureDirectedCompany;
  }

  set directedCompany (value: string) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "directedCompany", value });
  }

  get isPoliticallyAffiliated () {
    return this.drivewealthWizardStore.disclosureIsPoliticallyExposed;
  }

  set isPoliticallyAffiliated (value: boolean) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "isPoliticallyExposed", value });
  }

  get politicallyExposedNames () {
    return this.drivewealthWizardStore.disclosurePoliticallyExposedNames;
  }

  set politicallyExposedNames (value: string) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "politicallyExposedNames", value });
  }

  get hasSignatureContent () {
    return this.drivewealthWizardStore.hasSignatureContent;
  }

  get annualIncome () {
    return this.drivewealthWizardStore.disclosureAnnualIncome;
  }

  set annualIncome (value: number) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "annualIncome", value });
  }

  get annualIncomeValidator () {
    return {
      required: true,
      included: this.incomeOptions.map(x => x.value),
    };
  }

  get netWorthTotal () {
    return this.drivewealthWizardStore.disclosureNetWorthTotal || 0;
  }

  set netWorthTotal (value: number) {
    this.drivewealthWizardStore.setToDrivewealthEnrollmentDraft({ key: "netWorthTotal", value });
  }

  get netWorthTotalValidator () {
    return {
      required: true,
      included: this.netWorthOptions.map(x => x.value),
    };
  }

  selectState (veeValidateName: string) {
    return this.errors.has(veeValidateName) ? false : null;
  }

  get incomeOptions () {
    return [
      { value: 2500, text: "$0 - $4,999" },
      { value: 15000, text: "$5,000 - $24,999"},
      { value: 37500, text: "$25,000 - $49,999" },
      { value: 75000, text: "$50,000 - $99,999" },
      { value: 150000, text: "$100,000 - $199,999" },
      { value: 350000, text: "$200,000 - $499,999" },
      { value: 750000, text: "$500,000+" },
    ];
  }

  get netWorthOptions () {
    return [
      { value: 2500, text: "$0 - $4,999" },
      { value: 15000, text: "$5,000 - $24,999"},
      { value: 37500, text: "$25,000 - $49,999" },
      { value: 75000, text: "$50,000 - $99,999" },
      { value: 150000, text: "$100,000 - $199,999" },
      { value: 350000, text: "$200,000 - $499,999" },
      { value: 750000, text: "$500,000 - $999,999" },
      { value: 3000000, text: "$1,000,000 - $4,999,999" },
      { value: 7500000, text: "$5,000,000+" },
    ];
  }
}
